export const onVibrate = (intensivity) => {
  if (window.navigator && window.navigator.vibrate) {
    let TgVibro = window.Telegram.WebApp.HapticFeedback;
    if (intensivity === "click") {
      TgVibro.selectionChanged();
      // TgVibro.impactOccurred('heavy')
    } else if (intensivity === "error") {
      TgVibro.impactOccurred("rigid");
    } else if (intensivity === "success") {
      TgVibro.impactOccurred("soft");
    } else if (intensivity === "warning") {
      TgVibro.impactOccurred("medium");
    }
  }
};

export const setMakeDate = (date) => {
  let data = new Date();
  let formattedDate;
  let today = data.toISOString().slice(0, 10);
  if (date.id === 1) {
    formattedDate = data.toISOString().slice(0, 10);
  } else if (date.id === 2) {
    data.setDate(data.getDate() - 1);
    formattedDate = data.toISOString().slice(0, 10);
    today = formattedDate;
  } else if (date.id === 3) {
    data.setDate(data.getDate() - 7);
    formattedDate = data.toISOString().slice(0, 10);
  } else if (date.id === 4) {
    data.setDate(data.getDate() - 30);
    formattedDate = data.toISOString().slice(0, 10);
  } else if (date.id === 5) {
    formattedDate = "";
  } else {
    data.setDate(1);
    formattedDate = data.toISOString().slice(0, 10);
  }
  return {
    from: formattedDate,
    to: today,
  };
};

export const getMonthFirstAndLastDay = (customMounth) => {
  const now = new Date();
  const year = now.getFullYear();
  let month;
  if (customMounth) {
    month = customMounth;
  } else {
    month = now.getMonth();
  }

  let firstDayOfMonth;
  let lastDayOfMonth;

  if (customMounth) {
    firstDayOfMonth = new Date(year, month - 1, 1);
    lastDayOfMonth = new Date(year, month, 0);
  } else {
    firstDayOfMonth = new Date(year, month, 1);
    lastDayOfMonth = new Date(year, month + 1, 0);
  }

  const firstDay = formatDate(firstDayOfMonth);
  const lastDay = formatDate(lastDayOfMonth);

  return { firstDay, lastDay };
};

export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
